export default __webpack_public_path__ + "static/media/home_textile.94386d94.jpg";